<template>
  <svg viewBox="0 0 1024 1024" fill="currentColor">
    <path
      d="M640 170.666667H213.333333v682.666666h597.333334V341.333333h-170.666667V170.666667zM128 127.658667C128 104.277333 147.072 85.333333 170.581333 85.333333H682.666667l213.333333 213.333334v596.992A42.666667 42.666667 0 0 1 853.632 938.666667H170.368A42.666667 42.666667 0 0 1 128 896.341333V127.658667zM554.666667 512v170.666667h-85.333334v-170.666667H341.333333l170.666667-170.666667 170.666667 170.666667h-128z"
    />
  </svg>
</template>
